// extracted by mini-css-extract-plugin
export default {"title":"ServiceType_title__9YQiJ"};